import React, { useState, useEffect, useContext } from "react";
import SearchCompany from "../components/DeliveryFlow/SearchCompany";
import AddMembersScreen from "../components/DeliveryFlow/AddMembersScreen";
import DeliveryLocationScreen from "../components/DeliveryFlow/DeliveryLocationScreen";
import ResidentDetailsScreen from "../components/DeliveryFlow/ResidentDetailsScreen";
import ShippingLabelScreen from "../components/DeliveryFlow/ShippingLabelScreen";
import ShippingLabelCaptureScreen from "../components/DeliveryFlow/ShippingLabelCaptureScreen";
import DeliverySummaryScreen from "../components/DeliveryFlow/DeliverySummaryScreen";
import DeliveryQRCode from "../components/DeliveryFlow/DeliveryQRCode";
import { useDeliverySession } from "../hooks/useDeliverySession";
import Header from "../components/Header/DeliveryHeader";
import backgroundImg from "../assets/images/dashboard_bgq.png";
import { AuthContext } from "../context/AuthContext";

const DeliveryDashboard = () => {
  const { session, updateDeliveryField } = useDeliverySession();

  // STEP STATE
  const [step, setStep] = useState(0);
  const [residentDetails, setResidentDetails] = useState(null);
  const { user, user_type } = useContext(AuthContext);
  const [locationData, setLocationData] = useState(null);
  const [parcelCount, setParcelCount] = useState(0);

  console.log("=== DeliveryDashboard Debug ===");
  console.log("Step:", step);
  console.log("Resident details:", residentDetails);
  console.log("Parcel count:", parcelCount);
  console.log("Session deliveries:", session?.deliveries);

  // Conditional scroll control
  useEffect(() => {
    window.scrollTo(0, 0);
    const SCROLLABLE_STEPS = [0, 5, 6];
    document.body.style.overflow = SCROLLABLE_STEPS.includes(step)
      ? "auto"
      : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [step]);

  // Load saved step
  useEffect(() => {
    if (!user) return;

    const savedStepRaw = localStorage.getItem("currentDeliveryStep");
    const savedStep = Number(savedStepRaw);

    console.log("Loading step from localStorage:", savedStep);

    if (!isNaN(savedStep)) {
      setStep(savedStep);
    } else {
      setStep(0);
      localStorage.setItem("currentDeliveryStep", "0");
    }
  }, [user, user_type]);

  // GO NEXT
  const goNext = () => {
    const nextStep = step + 1;
    console.log("Going to step:", nextStep);
    setStep(nextStep);
    localStorage.setItem("currentDeliveryStep", nextStep.toString());
  };

  // GO BACK
  const goBack = () => {
    const prevStep = Math.max(0, step - 1);
    console.log("Going back to step:", prevStep);
    setStep(prevStep);
    localStorage.setItem("currentDeliveryStep", prevStep.toString());
  };

  // Go to Specific Step
  const updateStep = (newStep) => {
    console.log("Updating to specific step:", newStep);
    setStep(newStep);
    localStorage.setItem("currentDeliveryStep", newStep.toString());
  };

  return (
    <div
      className="relative min-h-screen"
      style={{
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Header />
      <div className="w-full min-h-screen px-4 sm:px-6 py-6 relative">
        {step === 0 && (
          <SearchCompany
            onNext={goNext}
            updateDeliveryField={updateDeliveryField}
          />
        )}

        {step === 1 && (
          <DeliveryLocationScreen
            onBack={goBack}
            onNext={(locationDetails) => {
              console.log("Location details received:", locationDetails);
              setLocationData(locationDetails);

              // Extract parcel count from location details
              if (locationDetails?.parcelCount) {
                const newParcelCount = parseInt(
                  locationDetails.parcelCount,
                  10
                );
                console.log(
                  "Setting parcel count from location:",
                  newParcelCount
                );
                setParcelCount(newParcelCount);
              }

              goNext();
            }}
          />
        )}

        {step === 2 && (
          <ResidentDetailsScreen
            onBack={goBack}
            parcelCount={parcelCount}
            setParcelCount={setParcelCount}
            onNext={(residentData) => {
              console.log("Resident details received:", residentData);

              if (residentData) {
                setResidentDetails(residentData);

                // Update parcel count from resident data if available
                if (residentData.parcel_count) {
                  const newParcelCount = parseInt(
                    residentData.parcel_count,
                    10
                  );
                  console.log(
                    "Setting parcel count from resident:",
                    newParcelCount
                  );
                  setParcelCount(newParcelCount);
                }
              }

              goNext();
            }}
            locationData={locationData}
            setStep={updateStep}
          />
        )}

        {step === 3 && (
          <ShippingLabelScreen
            onBack={goBack}
            residentDetails={residentDetails}
            onNext={() => {
              console.log("Moving to label capture screen");
              console.log("Resident details at this point:", residentDetails);
              goNext();
            }}
          />
        )}

        {step === 4 && (
          <ShippingLabelCaptureScreen
            residentDetails={residentDetails}
            parcelCount={parcelCount}
            onBack={goBack}
            onNext={(imagesArray) => {
              console.log("Label images captured:", imagesArray);
              goNext();
            }}
          />
        )}

        {step === 5 && (
          <DeliverySummaryScreen
            setResidentDetails={setResidentDetails}
            setParcelCount={setParcelCount}
            onBack={goBack}
            setStep={updateStep}
            onNext={goNext}
          />
        )}
      </div>
    </div>
  );
};

export default DeliveryDashboard;
